import { useScryfallStatusContext } from '@/hooks/useScryfallStatusContext';
import { Alert, AlertDescription } from '@/components/ui/alert';

export const ScryfallStatusBanner = () => {
  const { isApiDown } = useScryfallStatusContext();

  if (!isApiDown) {
    return null;
  }

  return (
    <Alert variant="destructive" className="rounded-none border-x-0">
      <AlertDescription className="text-center">
        The Scryfall API is currently offline. Card search and deckbuilding may be affected.
      </AlertDescription>
    </Alert>
  );
};
